import { getStudioPopups } from '@services/MarppleShop/marppleShopStudioApp/features/Popup/api';
import { Popup } from '@services/MarppleShop/shared/components/cells/Popup/Popup.ts';
import { noop } from '@fxts/core';
import { UtilS } from '@modules/Util/S/Function/module/UtilS';

/**
 * 스튜디오 내에서 팝업을 csr 방식으로 띄울 수 있는 기능입니다.
 * 마플샵 어드민내 '스튜디오 팝업 관리' 에서 설정할 수 있습니다.
 * ness 에서는 사용이 불가합니다.
 */
export const openStudioPopup = () => {
  if (UtilS.isNessApp()) {
    return void 0;
  }

  getStudioPopups(box.sel('store_id'), box.sel('domain_name'))
    .then((popups) => {
      if (popups.length) {
        Popup.createPopup({ popups })?.setBackDrop(true).setAlign('center').openPopup();
      }
    })
    .catch(noop);
};
